// import PropTypes from "prop-types"
// import { graphql } from "gatsby"

// import ImageOrVideo from "../../atoms/ImageOrVideo"

// import Button from "../../atoms/Button"
// import Flex from "../../atoms/Flex"
// import SectionTitle from "../SectionTitle"
// import Box from "../../atoms/Box"
// import SocialLink from "../../utils/SocialLink"
import React from "react"
import Reveal from "../../../utils/Reveal"

import Box from "../../../atoms/Box"
import LayoutChanger from "../../../atoms/LayoutChanger"
import StandardPadding from "../../../atoms/StandardPadding"

import * as Utils from "./utils"

const ImageTextMolecule = props => {
  // const normalizedProps = props.imageTextMolecule
  //   ? {
  //       ...props.imageTextMolecule,
  //       isMediaPositioningFloating: props.isMediaPositioningFloating,
  //       overlap: props.overlap,
  //     }
  //   : props
  // normalized props is for handling section vs popup prop data shape

  const {
    childrenStyles,
    standardPaddingProps,
    renderSectionTitle,
    hasImageOrVideo,
    renderImageOrVideo,
    location,
    align,
    marginBtwChilds,
    renderCard,
    layoutType,
  } = Utils.useMemoizedProps(props)

  let conditionalProps = {}
  if (layoutType === "stacked") {
    conditionalProps = {
      ...conditionalProps,
      py: 0,
    }
  }

  if (location !== "bottom" && props.mediaPositioning === "floating") {
    conditionalProps = {
      ...conditionalProps,
      pt: location === "top" ? 6 : 2,
    }
  }

  const standardPaddingStyles = {
    ...standardPaddingProps,
    ...conditionalProps,
  }

  return (
    <Box
      {...props.wrapperStyles}
      height="100%"
      minHeight={
        !props.isMediaPositioningFloating
          ? { _: "100%", lg: props.overlap ? "100%" : "350px" }
          : "100%"
      } // adding height to text box to make vertical padding slider work better>
    >
      {renderSectionTitle}
      <LayoutChanger
        itemsMoveStackedOnColumn={props.overlap ? false : true}
        // itemsMoveStackedOnColumn={normalizedProps.overlap ? false : true}
        {...childrenStyles}
        location={location}
        child1Px={props.child1Px}
        align={align}
        marginBtwChilds={marginBtwChilds}
        reverse={true}
        child1FlexDirOnMobile={
          props.mediaPositioningOnMobile === "top" ? "column-reverse" : "column"
        }
        height="100%"
      >
        <Reveal height="100%" width="100%">
          <StandardPadding {...standardPaddingStyles}>
            {renderCard}
          </StandardPadding>
        </Reveal>
        {hasImageOrVideo && renderImageOrVideo}
      </LayoutChanger>
    </Box>
  )
}

export default ImageTextMolecule

// ImageTextMolecule.propTypes = {
//   strapi_id: PropTypes.number.isRequired,
//   sectionTitle: PropTypes.shape(SectionTitle.strapiProps).isRequired,
//   button: PropTypes.shape(Button.strapiProps),
//   button2: PropTypes.shape(Button.strapiProps),
//   imageOrVideo: PropTypes.shape(ImageOrVideo.strapiProps),
//   layoutChanger: PropTypes.shape(LayoutChanger.strapiProps),
//   mediaPositioning: PropTypes.oneOf(["floating", "fit", "fitToHeight"]),
//   mediaPositioningOnMobile: PropTypes.oneOf(["top", "bottom"]),
//   child1Px: PropTypes.number,
//   imageTextAlign: PropTypes.oneOf(["start", "center", "end"]),
//   align: PropTypes.oneOf(["start", "center", "end"]),
//   location: PropTypes.oneOf(["top", "bottom", "left", "right"]),
//   imageTextLocation: PropTypes.oneOf(["top", "bottom", "left", "right"]),
//   layoutStyle: PropTypes.oneOf(["standard", "overlapping"]),
//   mediaLocation: PropTypes.oneOf(["left", "right"]),
//   mediaRatio: PropTypes.number,
//   useNewsletter: PropTypes.bool,
//   xOffsetOverlap: PropTypes.number,
//   yOffsetOverlap: PropTypes.number,
//   text: PropTypes.shape(SectionTitle.strapiProps).isRequired,
//   socialLinks: PropTypes.shape(SocialLink.strapiProps),
//   socialLinkStyles: PropTypes.shape(SocialLink.strapiProps),
// }

// export const query = graphql`
//   fragment ImageTextMolecule on STRAPI__COMPONENT_POPUPS_IMAGE_TEXT_POPUP {
//     strapi_id
//     sectionTitle {
//       ...SectionTitle
//     }
//     button {
//       ...Button
//     }
//     button2 {
//       ...Button
//     }
//     imageOrVideo {
//       ...ImageOrVideo
//     }
//     layoutChanger {
//       ...LayoutChanger
//     }
//     child1Px
//     text {
//       ...SectionTitle
//     }
//     card {
//       ...Card
//     }
//     verticalText {
//       ...VerticalText
//     }
//     socialLinks {
//       ...SocialLink
//     }
//     socialLinkStyles {
//       ...SocialLinkStyles
//     }
//     align
//     location
//     mediaLocation
//     mediaRatio
//     useNewsletter
//     xOffsetOverlap
//     yOffsetOverlap
//     mediaPositioning
//     mediaPositioningOnMobile
//   }
// `
